import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";

const SpeakerTopicsTwo = () => {
    return (
        <div className="rn-splite-style px-4 py-10 md:py-16">
            <div className="max-w-4xl mx-auto space-y-8">
                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    <h3 className="text-3xl font-semibold tracking-tight mb-4">Signature Formats:</h3>
                </ScrollAnimation>


                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    <ul className="space-y-3">
                        <li className="mb-1"> Keynote (30–60 mins).</li>
                        <li className="mb-1"> Workshop (Half-day / Full-day)</li>
                        <li className="mb-1"> Online Masterclasses</li>
                        
                    </ul>
                </ScrollAnimation>

                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    <h3 className="text-3xl font-semibold tracking-tight mb-4">Target Audiences Served:</h3>
                </ScrollAnimation>

                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    <ul className="space-y-3">
                        <li className="mb-1"> Business events & startup expos</li>
                        <li className="mb-1"> Corporate leadership retreats</li>
                        <li className="mb-1"> University entrepreneurship clubs</li>
                        <li className="mb-1"> Investment or real estate forums</li>
                        
                    </ul>
                </ScrollAnimation>

            </div>
        </div>
    );
};

export default SpeakerTopicsTwo;
